/* eslint-disable @typescript-eslint/no-explicit-any */
import EmptyBoxVector from '@/utils/vectors/EmptyBoxVector'
import { Typography } from 'antd'
import styled from 'styled-components'

const EmptyLayoutStyled = styled.div`
  text-align: center;
  margin-top: 1vh;
  .wrapper {
    width: 314px;
    margin: 0 auto;
  }
  > svg {
    margin-bottom: 60px;
  }
  p {
    text-align: center;
    margin-bottom: 24px;
  }
`
const { Text } = Typography
const EmptyLayout = (props: any) => {
  const { notFound: copy } = props || {}
  return (
    <EmptyLayoutStyled>
      <div className="wrapper">
        <EmptyBoxVector />
        <Text>{copy?.notFound?.specialProduct?.textNoLogged}</Text>
      </div>
    </EmptyLayoutStyled>
  )
}

export default EmptyLayout
